import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { Page, Header, Alert } from 'components';
import { CardHeader, Card, Divider, CardContent, Grid, Button } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import SiteDownTimeTable from './SiteDownTimeTable';
import SiteDownTimeImportModal from './SiteDownTimeImportModal';

import { GetSiteDownTimeTable, ToggleImportModalVisibility } from '../actions/SiteDownTimeActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const SiteDownTime = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const siteDownTimeTableData = useSelector((state) => state.siteDownTimeReducer.siteDownTimeTableData);
	const importModalVisibility = useSelector((state) => state.siteDownTimeReducer.importModalVisibility);
	const [modalTitle, setModalTitle] = useState('Empty');

	const _onImportClick = (buttonTitle) => {
		setModalTitle(buttonTitle);
		dispatch(ToggleImportModalVisibility(true));
	};

	const _onCloseImportModal = () => {
		dispatch(ToggleImportModalVisibility(false));
	};

	useEffect(() => {
		dispatch(GetSiteDownTimeTable());
	}, []);

	return (
		<Page className={classes.root} title="Files Upload">
			<Header module="Files Upload" view="Site DownTime" />
			<br />
			<Grid container spacing={2}>
				<Grid item lg={12} xs={12}>
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="medium"
						startIcon={<FileUploadIcon />}
						onClick={() => _onImportClick('DWT')}
					>
						Import DWT
					</Button>
					{' '}
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="medium"
						startIcon={<FileUploadIcon />}
						onClick={() => _onImportClick('Tower DB')}
					>
						Import Tower DB
					</Button>
					{' '}
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="medium"
						startIcon={<FileUploadIcon />}
						onClick={() => _onImportClick('Inc Massiva')}
					>
						Import Incs Massivas
					</Button>
					{' '}
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="medium"
						startIcon={<FileUploadIcon />}
						onClick={() => _onImportClick('Inc Tickets')}
					>
						Import Inc Tickets
					</Button>
				</Grid>
			</Grid>
			<br />
			<Grid item lg={12} xs={12}>
				<SiteDownTimeTable className={classes.results} data={siteDownTimeTableData} />
			</Grid>
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					{importModalVisibility && (
						<SiteDownTimeImportModal
							onClose={_onCloseImportModal}
							open={importModalVisibility}
							title={modalTitle}
						/>
					)}
				</Grid>
			</Grid>
		</Page>
	);
};

export default SiteDownTime;
